<div class="grid-4col input-grid-gaps">
    <app-select-input
        [infiniteScroll]="store.accountScroll"
        [form]="form()"
        id="unpostedTransactionsAccountId"
        [prefix]="translatePrefix"
        valueKey="id"
        [autoDisplayFirst]="false"
    >
        <ng-template #item let-item>
            {{ madoAccountToDropdownOptionString(item) }}
        </ng-template>
        <ng-template #selectedItem let-item>
            {{ madoAccountToDropdownOptionString(item) }}
        </ng-template>
    </app-select-input>
    <app-select-input
        [infiniteScroll]="store.accountScroll"
        [form]="form()"
        id="gainExchangeAccountId"
        [prefix]="translatePrefix"
        valueKey="id"
        [autoDisplayFirst]="false"
    >
        <ng-template #item let-item>
            {{ madoAccountToDropdownOptionString(item) }}
        </ng-template>
        <ng-template #selectedItem let-item>
            {{ madoAccountToDropdownOptionString(item) }}
        </ng-template>
    </app-select-input>
    <app-select-input
        [infiniteScroll]="store.accountScroll"
        [form]="form()"
        id="lossExchangeAccountId"
        [prefix]="translatePrefix"
        valueKey="id"
        [autoDisplayFirst]="false"
    >
        <ng-template #item let-item>
            {{ madoAccountToDropdownOptionString(item) }}
        </ng-template>
        <ng-template #selectedItem let-item>
            {{ madoAccountToDropdownOptionString(item) }}
        </ng-template>
    </app-select-input>
</div>
